import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { CUSTOMER_CONFIG } from "../../configs";

export const getCustomerConfig = createAsyncThunk(
    "customerConfig/get",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(CUSTOMER_CONFIG);
            return response.data;
        } catch (err: any) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

export const updateCustomerConfig = createAsyncThunk(
    "customerConfig/update",
    async (data: { cronExpression: string; inactivityWindowDays: number; timeZone: string }, { rejectWithValue }) => {
        try {
            const response = await axios.put(CUSTOMER_CONFIG, data);
            return response.data;
        } catch (err: any) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);
